<template>
  <div class="km-prod-card">
    <div class="card-image">
      <img :src="img" :alt="title" />
      <div class="card-image-overlay">
        <span class="view-more-text">查看详情</span>
      </div>
    </div>
    <div class="card-body">
      <h3 class="card-title">{{ title }}</h3>
      <p class="card-desc">{{ content }}</p>
      <div class="card-footer">
        <button class="card-btn">
          查看详情
          <Icon type="ios-arrow-forward" size="14" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'prod-card',
  props: {
    title: String,
    img: String,
    content: String,
  },
};
</script>

<style lang="less" scoped>
.km-prod-card {
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-xs);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    box-shadow: var(--shadow-md);
    transform: translateY(-6px);
    border-color: rgba(0, 86, 179, 0.25);

    .card-image-overlay {
      opacity: 1;
    }

    .card-image img {
      transform: scale(1.06);
    }

    .card-btn {
      background: var(--accent-hover);
    }
  }
}

/* 图片区域 */
.card-image {
  width: 100%;
  height: 220px;
  overflow: hidden;
  position: relative;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

.card-image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 56, 130, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;

  .view-more-text {
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1px;
  }
}

/* 卡片主体 */
.card-body {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.card-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--primary);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
}

.card-desc {
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-secondary);
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  flex: 1;
}

/* 卡片底部按钮 */
.card-footer {
  margin-top: 8px;
  padding-top: 14px;
  border-top: 1px solid var(--border-color);
}

.card-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: var(--accent);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.25);

  &:hover {
    background: var(--accent-hover);
    box-shadow: 0 4px 14px rgba(255, 140, 0, 0.35);
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .card-image {
    height: 190px;
    padding: 12px;
  }

  .card-body {
    padding: 16px;
    gap: 8px;
  }

  .card-title {
    font-size: 15px;
  }
  .card-desc {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .card-image {
    height: 170px;
    padding: 10px;
  }

  .card-body {
    padding: 14px;
  }

  .card-title {
    font-size: 14px;
  }
}
</style>
